var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table",
    { staticClass: "carrier-manifests-table" },
    [
      _c(
        "md-table-row",
        { attrs: { slot: "md-table-head" }, slot: "md-table-head" },
        [
          _c("md-table-head", [_vm._v("Shipping Date")]),
          _c("md-table-head", [_vm._v("Carrier")]),
          _c("md-table-head", [_vm._v("No. of Packages")]),
          _c("md-table-head", [_vm._v("Actions")]),
        ],
        1
      ),
      _vm.manifests.length === 0
        ? [
            _c(
              "md-table-row",
              [
                _c(
                  "md-table-cell",
                  { staticClass: "text-center", attrs: { colspan: "4" } },
                  [
                    _vm._v(
                      "\n                No manifests available.\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._l(_vm.manifests, function (manifest) {
            return [
              _c(
                "md-table-row",
                {
                  key: manifest.carrierJobManifestId,
                  class: {
                    "active-manifest":
                      _vm.activeManifestId === manifest.carrierJobManifestId,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.activateManifest(manifest)
                    },
                  },
                },
                [
                  _c("md-table-cell", [
                    _vm._v(
                      _vm._s(
                        manifest.shippingDate
                          ? _vm.formatDate(manifest.shippingDate)
                          : ""
                      )
                    ),
                  ]),
                  _c("md-table-cell", { staticClass: "carrier-cell" }, [
                    _c("img", {
                      staticClass: "carrier-logo",
                      attrs: { src: manifest.carrierLogoUrl, alt: "logo" },
                    }),
                    _c("span", [_vm._v(_vm._s(manifest.carrierName))]),
                  ]),
                  _c("md-table-cell", [_vm._v(_vm._s(manifest.packagesCount))]),
                  _c("md-table-cell", [
                    manifest.hasDownloadableDocument
                      ? _c(
                          "div",
                          { staticClass: "action-group" },
                          [
                            manifest.downloadUrl
                              ? _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-accent md-just-icon md-round",
                                    attrs: {
                                      href: manifest.downloadUrl,
                                      target: "_blank",
                                      title: "Download manifest",
                                    },
                                  },
                                  [_c("md-icon", [_vm._v("downloading")])],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "md-button",
                              {
                                staticClass: "md-accent md-just-icon md-round",
                                attrs: { title: "Download all labels" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit(
                                      "download-labels",
                                      manifest
                                    )
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("file_download")])],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm.activeManifestId === manifest.carrierJobManifestId
                ? _c(
                    "md-table-row",
                    { key: "nested-row-" + manifest.carrierJobManifestId },
                    [
                      _c(
                        "md-table-cell",
                        {
                          staticClass: "nested-table-cell",
                          attrs: { colspan: "4" },
                        },
                        [
                          _vm.isOrdersLoading
                            ? _c("skeleton-table")
                            : _c("simplified-order-table", {
                                attrs: {
                                  orders: _vm.fetchedOrders,
                                  "is-read-only-user": _vm.isReadOnlyUser,
                                  "column-dropdown-options":
                                    _vm.columnDropdownOptions,
                                  "selected-column": _vm.selectedColumn,
                                },
                                on: {
                                  "column-selected": _vm.handleSelectedColumn,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }